import { getTheme } from "../../../graphic/theme";

import { STAR_NUMBER_TYPE } from "../../../graphic/constants";

import { BaseRender } from "./base-render";

import { defaultStarBackgroundRenderContribution, defaultStarTextureRenderContribution } from "./contributions";

export class DefaultCanvasStarRender extends BaseRender {
    constructor(graphicRenderContributions) {
        super(), this.graphicRenderContributions = graphicRenderContributions, this.numberType = STAR_NUMBER_TYPE, 
        this.builtinContributions = [ defaultStarBackgroundRenderContribution, defaultStarTextureRenderContribution ], 
        this.init(graphicRenderContributions);
    }
    drawShape(star, context, x, y, drawContext, params, fillCb, strokeCb) {
        const starAttribute = getTheme(star, null == params ? void 0 : params.theme).star, {x: originX = starAttribute.x, y: originY = starAttribute.y, fillStrokeOrder: fillStrokeOrder = starAttribute.fillStrokeOrder} = star.attribute, data = this.valid(star, starAttribute, fillCb, strokeCb);
        if (!data) return;
        const {fVisible: fVisible, sVisible: sVisible, doFill: doFill, doStroke: doStroke} = data, points = star.getCachedPoints();
        context.beginPath(), points && points.length && points.forEach(((point, index) => {
            0 === index ? context.moveTo(x + point.x, y + point.y) : context.lineTo(x + point.x, y + point.y);
        })), context.closePath(), context.setShadowBlendStyle && context.setShadowBlendStyle(star, star.attribute, starAttribute), 
        this.beforeRenderStep(star, context, x, y, doFill, doStroke, fVisible, sVisible, starAttribute, drawContext, fillCb, strokeCb);
        const _runFill = () => {
            doFill && (fillCb ? fillCb(context, star.attribute, starAttribute) : fVisible && (context.setCommonStyle(star, star.attribute, originX - x, originY - y, starAttribute), 
            context.fill()));
        }, _runStroke = () => {
            doStroke && (strokeCb ? strokeCb(context, star.attribute, starAttribute) : sVisible && (context.setStrokeStyle(star, star.attribute, originX - x, originY - y, starAttribute), 
            context.stroke()));
        };
        fillStrokeOrder ? (_runStroke(), _runFill()) : (_runFill(), _runStroke()), this.afterRenderStep(star, context, x, y, doFill, doStroke, fVisible, sVisible, starAttribute, drawContext, fillCb, strokeCb);
    }
    draw(star, renderService, drawContext, params) {
        const starAttribute = getTheme(star, null == params ? void 0 : params.theme).star;
        this._draw(star, starAttribute, !1, drawContext, params);
    }
}
//# sourceMappingURL=star-render.js.map
